import $ from 'jquery';
import autoComplete from "@tarekraafat/autocomplete.js";

if ($('#partnerSearch').length) {
    const autoCompleteJS = new autoComplete({
      searchEngine: (q, r) => {
        const query = q.toLowerCase();
        const title = r.title.toLowerCase();
        const abbreviation = r.abbreviation.toLowerCase();

        if (title.includes(query)) {
          return r;
        }
        if (abbreviation.includes(query)) {
          return r;
        }
        return false;
      },
      data: {
        src: async () => {
          try {
            // Loading placeholder text
            document
              .getElementById("partnerSearch")
              .setAttribute("placeholder", "Loading...");
            // setup
            const setdata = new FormData();
            setdata.append('action', 'get_partners_list');
            // Fetch External Data Source
            const source = await fetch(EAPLUS_VARS.ajax_url, {
              method: "POST",
              credentials: 'same-origin',
              body: setdata
            });
            const data = await source.json();
            // Post Loading placeholder text
            document
              .getElementById("partnerSearch")
              .setAttribute("placeholder", autoCompleteJS.placeHolder);
            // Returns Fetched data
            return data;
          } catch (error) {
            return error;
          }
        },
        cache: true
      },
      selector: "#partnerSearch",
      placeHolder: "Search for Partners...",
      resultsList: {
        element: (list, data) => {
          const info = document.createElement("p");
          if (data.results.length > 0) {
            info.innerHTML = `Displaying <strong>${data.results.length}</strong> out of <strong>${data.matches.length}</strong> results`;
          } else {
            //info.innerHTML = `Found <strong>${data.matches.length}</strong> matching results for <strong>"${data.query}"</strong>`;
            //info.innerHTML = `Not found what you were looking for. <a href="${EAPLUS_VARS.partner_search_no_result_page_url}"><u>Click here</u></a>`;
            info.innerHTML = `Unable to locate the partner you are searching for. Try a different spelling or abbreviation, or request to add them below.`;
          }
          list.prepend(info);
        },
        noResults: true,
        maxResults: 15,
        tabSelect: true
      },
      resultItem: {
        element: (item, data) => {
          // Modify Results Item Style
          item.style = "display: flex; justify-content: space-between;";
          // Modify Results Item Content
          item.innerHTML = `
        <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
          ${data.value.title}
        </span>
        <span style="display: flex; align-items: center; font-size: 13px; font-weight: 100; text-transform: uppercase; color: rgba(0,0,0,.2);">
          ${data.value['abbreviation']}
        </span>`;
        },
        highlight: true
      },
      events: {
        input: {
          selection: (event) => {
            const selection = event.detail.selection.value;
            autoCompleteJS.input.value = selection.title;
            document.querySelector('#partnerSearch').setAttribute('data-partner-url', selection.url);
          },
          focus: () => {
            if (autoCompleteJS.input.value.length) autoCompleteJS.start();
          }
        }
      }
    });

    $('#browse-partner-company').on('click', function(e) {
      e.preventDefault();
      if ($('#inputZipCompany').val()) {
        var partner_url = document.querySelector('#partnerSearch').getAttribute('data-partner-url');
        if (partner_url != '') {
          if (isExternal(partner_url)) {
            window.open(partner_url, '_blank');
          } else {
            window.location.href = partner_url;
          }
        }
      }
      return false;
    });

    $('#browse-partner-category').on('click', function(e) {
      e.preventDefault();
      if ($('#inputZipCategory').val()) {
        var category_url = $('#selectCategory').val();
        if (category_url) {
          window.location.href = category_url;
          return false;
        }
      }
    });

    function isExternal(url) {
      var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
      if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
      if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + {
          "http:": 80,
          "https:": 443
        } [location.protocol] + ")?$"), "") !== location.host) return true;
      return false;
    }

}
